import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { AlertService } from 'app/core/alerts/alert.service';
import { formatTime, inputTimeToDecimal } from 'app/shared/time';

@Component({
    selector: 'app-resourceplan-timer-input',
    templateUrl: './resourceplan-timer-input.component.html',
    styleUrls: ['./resourceplan-timer-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ResourceplanTimerInputComponent {
    @Input() timer: number;
    @Input() disabled: boolean;
    @Output() saveTimer = new EventEmitter<number>();

    @ViewChild('timerInput') timerInput: ElementRef;

    constructor(
        private alert: AlertService
    ) { }

    onChangeTimer(newValue: string) {
        if (!newValue && !this.timer) { return; }
        const convertedValue = inputTimeToDecimal(newValue);
        if (isNaN(+convertedValue)) {
            this.alert.createAlert('Der er fejl i den indtastede værdi', 'danger');
            this.timerInput.nativeElement.focus();
            this.timerInput.nativeElement.select();
            return;
        }
        if (+convertedValue === this.timer) {
            this.timerInput.nativeElement.value = formatTime(this.timer);
            return;
        }
        this.saveTimer.emit(+convertedValue);
    }
}
